import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteContactsService {

  constructor(private http: HttpClient) { }

  public getAllSiteContactsBySiteId(id, pagination) {
    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    const sortString = '&sort=emergencyContact,contactName';

    return this.http.get(environment.apiUrl + 'api/ext-notification-contact/by-site/' + id + paginationString + sortString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public createSiteContact(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-notification-contact/create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public deleteSiteContact(id) {
    return this.http.delete(environment.apiUrl + 'api/ext-notification-contact/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public updateSiteContact(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-notification-contact/', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
